import { GridColumns as VisxGridColumns } from '@visx/grid';
import { AllGridColumnsProps } from '@visx/grid/lib/grids/GridColumns';

import { GridLines } from './GridLines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';
import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';

export type GridColumnsProps = {
  highlightZeroLine?: boolean;
} & AllGridColumnsProps<AnyScale>;

export const GridColumns = ({
  scale,
  highlightZeroLine = true,
  ...restProps
}: GridColumnsProps) => (
  <VisxGridColumns scale={scale} {...restProps}>
    {({ lines }) => (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    )}
  </VisxGridColumns>
);
